<template>
  <el-dialog
    title="地址选择"
    :visible.sync="mapDialogShow"
    :append-to-body="false"
    :modal="false"
    :destroy-on-close="true"
    @before-close="beforeClose"
    width="400px"
    custom-class="mapClass"
  >
    <div
      id="mapcontrol"
      v-loading="maploading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    ></div>
    <div class="info">
      <div class="input-item">
        <el-input
          size="mini"
          id="tipinput"
          type="text"
          v-model="tipinputValue"
          placeholder="搜索地点"
        />
      </div>
    </div>
    <div class="form-wrap">
      <el-input
        disabled
        placeholder="选择地址"
        v-model="confirmData.address"
      ></el-input>
      <el-select
        v-if="addCircle"
        v-model="confirmData.distance"
        placeholder="选择距离"
        @change="onDistanceChange"
        style="width: 100%; margin-top: 12px"
      >
        <el-option
          v-for="item in distanceOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button class="confirm-btn" type="primary" @click="handleConfirm">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";

var AMap;
export default {
  data() {
    return {
      mapDialogShow: false,
      maploading: true,
      type: "",
      tipinputValue: "",
      confirmData: {
        lng: "",
        lat: "",
        address: "",
        adCode: "",
      },
      distanceOptions: [
        { value: 1000, label: "1000米" },
        { value: 500, label: "500米" },
        { value: 200, label: "200米" },
        { value: 100, label: "100米" },
        { value: 50, label: "50米" },
      ],
    };
  },
  computed: {
    addCircle() {
      return this.type.indexOf("distance") > -1;
    },
  },
  methods: {
    /**
     * @description 初始化地图
     * @param address 地址信息
     * @param lng 经度
     * @param lat 纬度
     * @param distance 可选参数, 选择范围
     * @param type 可选参数, 默认(address), 返回地址信息和经纬度; 传入 (address,distance) 提供范围选择能力
     */
    init({ address, lng, lat, distance = 50, type = "address" }) {
      this.type = type;
      this.confirmData = {
        address,
        lng,
        lat,
        ...(this.addCircle && { distance }),
      };
      this.mapDialogShow = true;
      AMapLoader.reset(); // 重置,解决多种sdk调用方式报错
      AMapLoader.load({
        key: "7dc47d41fcae03dd21eb7736411ccfee",//"b114b461abee8f7dac4c60ecc3828b78", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Autocomplete", "AMap.PlaceSearch", "AMap.Geocoder"],
      })
        .then((Map) => {
          AMap = Map;
          const { setCircleRadius } = this.initMap();
          this.setCircleRadius = setCircleRadius;
          this.maploading = false;
        })
        .catch((error) => {
          console.log("_Load error", error);
        });
    },
    initMap() {
      var _this = this;
      this.map = new AMap.Map("mapcontrol", {
        zoom: 18, //初始化地图级别
        center: [120.699279, 27.993849], //初始化地图中心点位置
      });

      var marker; // 初始化 marker
      var circle;
      var infoWindow = new AMap.InfoWindow({
        autoMove: true,
        offset: { x: 0, y: -30 },
      });

      //  已设置, 初始化位置 * 1
      if (
        this.confirmData.address &&
        this.confirmData.lng &&
        this.confirmData.lat
      ) {
        const lnglat = new AMap.LngLat(
          this.confirmData.lng,
          this.confirmData.lat
        );
        createMarker(lnglat);
        this.addCircle && createCircle(lnglat);
        this.map.setCenter(marker.getPosition());
        markerDragendRegister();
        openWindow();
      }

      // 地图点击 * 2
      this.map.on("click", async (e) => {
        const lnglat = new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat());
        createMarker(lnglat);
        this.addCircle && createCircle(lnglat);
        await regeoCode([lnglat.getLng(), lnglat.getLat()]);
        markerDragendRegister();
        openWindow();
      });

      var autoComplete = new AMap.Autocomplete({
        input: "tipinput",
        datatype: "poi", //  检索 poi
        // city: "全国",
        city: "温州市",
        citylimit: true,
      });
      // 监听autoComplete选择 * 3
      autoComplete.on("select", async ({ poi, type }) => {
        // console.log('_autoComplete select', poi);
        const lnglat = new AMap.LngLat(
          poi.location.getLng(),
          poi.location.getLat()
        );
        createMarker(lnglat);
        this.addCircle && createCircle(lnglat);
        markerDragendRegister();
        await regeoCode([lnglat.getLng(), lnglat.getLat()]);
        openWindow();
      });
      autoComplete.on("complete", (res) => {
        console.log("_autoComplete.on complete", res);
      });
      autoComplete.on("error", (res) => {
        console.error("_autoComplete.on error", res);
        message.error(res.info);
      });

      /** 根据经纬度逆推地理信息并赋值设置*/
      function regeoCode(lnglat) {
        return new Promise((resolve, reject) => {
          var geocoder = new AMap.Geocoder();
          geocoder.getAddress(lnglat, function (status, result) {
            // console.log('_geocoder.getAddress', status, result);
            if (status === "complete" && result.regeocode) {
              _this.confirmData = {
                ..._this.confirmData,
                lng: lnglat[0],
                lat: lnglat[1],
                address: result.regeocode.formattedAddress,
                adcode: result.regeocode.addressComponent.adcode,
              };
              resolve(result.regeocode);
            } else {
              reject("根据经纬度查询地址失败");
              // console.error('根据经纬度查询地址失败');
            }
          });
        });
      }
      /** marker拖动事件*/
      async function markerDragend(data) {
        _this.map.setCenter(marker.getPosition());
        const lnglat = data.lnglat;
        _this.addCircle && createCircle(lnglat);
        await regeoCode([lnglat.getLng(), lnglat.getLat()]);
        openWindow();
      }
      /** 创建标记点*/
      function createMarker(lnglat) {
        clearMarker(); //  只保留一个标记
        marker = new AMap.Marker({
          map: _this.map,
          position: lnglat,
          draggable: true,
        });
        _this.map.setCenter(marker.getPosition());
      }
      /** 创建区域覆盖物*/
      function createCircle(lnglat) {
        if (circle) {
          //  清除之前的 circle
          // _this.map.remove(circle);
          circle.setMap(null);
          circle = null;
        }
        circle = new AMap.Circle({
          center: lnglat, // 圆心位置
          radius: _this.confirmData.distance, //半径
          strokeColor: "#F33", //线颜色
          strokeOpacity: 1, //线透明度
          strokeWeight: 3, //线粗细度
          fillColor: "#ee2200", //填充颜色
          fillOpacity: 0.35, //填充透明度
        });
        _this.map.add(circle);
      }
      //  设置区域的距离
      function setCircleRadius() {
        if (circle) {
          circle.setRadius(_this.confirmData.distance);
        }
      }
      /** 清除标记点*/
      function clearMarker() {
        if (marker) {
          //  清除 marker
          marker.setMap(null);
          marker = null;
        }
      }
      /** 打开窗口信息*/
      function openWindow() {
        infoWindow.close();
        infoWindow.setContent(
          [
            "地址: " + _this.confirmData.address,
            "经纬度: [" +
              _this.confirmData.lng +
              ", " +
              _this.confirmData.lat +
              "]",
          ].join("<br>")
        );
        infoWindow.open(_this.map, marker.getPosition());
      }
      /** marker 拖动监听*/
      function markerDragendRegister() {
        marker.off("dragend", markerDragend); //  取消监听
        marker.on("dragend", markerDragend); // 监听
      }
      return {
        setCircleRadius,
      };
    },
    handleConfirm() {
      const confirmData = this.confirmData;
      // console.log("_confirmData", confirmData);
      this.$emit("onConfirm", confirmData);
      this.mapDialogShow = false;
    },
    onDistanceChange() {
      this.setCircleRadius();
    },
    beforeClose(done) {
      this.resetData();
      done();
    },
    resetData() {
      this.confirmData = {
        lng: "",
        lat: "",
        address: "",
        adCode: "",
      };
    },
  },
  mounted() {
    // https://lbs.amap.com/api/javascript-api-v2/guide/abc/jscode
    window._AMapSecurityConfig = {
      securityJsCode: "6ad50b45cd96a11d1c6de129be8276d9",
    };
  },
};
</script>
<style lang="less" scoped>
#mapcontrol {
  position: relative;
  width: 100%;
  height: 450px;
}
.info {
  position: absolute;
  left: 50px;
  top: 100px;
}
.form-wrap {
  margin-top: 24px;
  .confirm-btn {
    margin-top: 12px;
  }
}
</style>
